import { LinearProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useContext, useEffect, useState } from "react"
import { useQuery } from "react-query"
import { listLessons } from "~/actions/lessons"
import AdminActionBar from "~/components/Common/AdminActionBar"
import StatusFilters from "~/components/Common/StatusFilters"
import LessonCardList from "~/components/Lessons/LessonCardList"
import AppContext from "~/contexts/App"
import LessonsContext from "~/contexts/Lessons"
import Page from "~/pages/Page"
import Router from "~/router"
import Box from "../../../../components/Common/Box"
import useStyles from "./styles"

const List = ({ routes = [], ...rest }) => {
  const classes = useStyles()

  const { openDialog, setPageTitle, setPageSubTitle } = useContext(AppContext)
  const { createLessonMutation } = useContext(LessonsContext)
  //set serach value
  const [searchValue, setSearchValue] = useState("")
  //set sort data
  const [sort, setSort] = useState({
    name: "",
    type: "",
    direction: "",
    icon: "",
  })

  const filterOptions = [
    { id: 1, name: "Name" },
    { id: 2, name: "Last Updated" },
    { id: 3, name: "Duration" },
  ]

  const {
    data: lessons,
    isLoading: lessonsLoading,
    refetch: refetchLessons,
  } = useQuery("lessons", () => listLessons())

  //set lesson title and subtitle
  useEffect(() => {
    setPageTitle("Lessons")
    setPageSubTitle(lessons?.length)
  }, [lessons])

  //reusable dialog to create lessons, courses, clientes and instructor
  //pass a title, subtitle, type (for example course) a create mutation func and refecth data
  const openCreateDialog = () => {
    let data = {
      title: "New Lesson",
      subtitle: "Create a new Lesson",
      type: "lesson",
      create: createLessonMutation,
    }
    openDialog("createCourseLessonDialog", data)
  }
  const hash = window.location.hash
    ? window.location.hash.replace("#", "")
    : "published"
  //Lesson Status
  const [statusState, setStatusState] = useState(hash)
  const watchHash = () => {
    const newHash = window.location.hash.replace("#", "")
    if (newHash) {
      setStatusState(newHash)
    }
  }
  useEffect(() => {
    window.removeEventListener("hashchange", watchHash)
    window.addEventListener("hashchange", watchHash, false)
  })
  //set the length of each type of lesson
  const [statusNumber, setStatusNumber] = useState({
    published: null,
    unpublished: null,
    draft: null,
    archived: null,
  })

  if (sort?.direction === "") {
    sort.name = ""
    sort.type = ""
  }

  return (
    <Page>
      <AdminActionBar
        buttonName="New Lesson"
        buttonFunc={openCreateDialog}
        sortOptions={filterOptions}
        sortState={sort}
        setSortState={setSort}
        setFilterState={setSearchValue}
        placeholder="Search lessons"
      />
      {lessonsLoading ? (
        <LinearProgress color="primary" />
      ) : (
        <Box
          display="flex"
          height="100%"
          className={classes.container}
          flexWrap="wrap"
        >
          <Box className={classes.leftContainer}>
            <StatusFilters
              setStatusState={setStatusState}
              statusState={statusState}
              statusNumber={statusNumber}
            />
          </Box>

          <Box className={classes.rightContainer}>
            <LessonCardList
              lessons={lessons}
              searchValue={searchValue}
              sort={sort}
              openCreateDialog={openCreateDialog}
              statusState={statusState}
              setStatusNumber={setStatusNumber}
            />
          </Box>
        </Box>
      )}
      <Router routes={routes} {...rest} />
    </Page>
  )
}

List.propTypes = {
  routes: PropTypes.array,
}

export default List
